import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.74 29.334c-2.637 0-5.092-1.007-6.916-2.836-3.844-3.855-3.786-10.184.129-14.11l7.637-7.66a6.96 6.96 0 0 1 4.966-2.062c1.878 0 3.64.732 4.967 2.063 2.736 2.744 2.736 7.206 0 9.949l-7.675 7.695c-1.578 1.581-4.331 1.584-5.91 0a4.196 4.196 0 0 1 0-5.916l6.741-6.76a1.333 1.333 0 1 1 1.888 1.882l-6.741 6.76a1.527 1.527 0 0 0 0 2.151c.572.572 1.564.57 2.134 0l7.675-7.695a4.387 4.387 0 0 0 0-6.184c-1.645-1.649-4.51-1.649-6.156 0L8.842 14.27c-2.83 2.839-2.888 7.576-.128 10.344 1.318 1.323 3.105 2.052 5.028 2.052a7.5 7.5 0 0 0 5.279-2.179l6.702-6.722a1.333 1.333 0 1 1 1.888 1.882l-6.703 6.723a10.2 10.2 0 0 1-7.168 2.964"
    }, null, -1)
  ])))
}
export default { render: render }